// extracted by mini-css-extract-plugin
export default {"layout":"CreateChat_layout__1wuZo","icon":"CreateChat_icon__K0mPc"};